// extracted by mini-css-extract-plugin
module.exports = {"root":"CheckoutTitle_root__1bL3P","rootRtl":"CheckoutTitle_rootRtl__2dvZn"};